
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/affiliate-program-settings",
      function () {
        return require("private-next-pages/profile/affiliate-program-settings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/affiliate-program-settings"])
      });
    }
  